import React from 'react'
import AuthorInfoCard from './AuthorInfoCard'
import CardPopupWrapper from './CardPopupWrapper'

import styles from '../AllCards.module.css'

const StoryPopup = ({ story, setVisible, visible }) => {
  return (
    <CardPopupWrapper
      setVisible={setVisible}
      visible={visible}
      imageUrl={story.imageUrl}
      name={story.name}
      authorName={story.author.name}
    >
      <div className={styles['story-title']}>卡片故事</div>
      <div className={styles.story}>
        <div className={styles.header}>
          <div className={styles['story-name']}>{story.name}</div>
          <div className={styles['author-name']}>{story.author.name}</div>
          <img
            src={require(`../../../assets/images/buy_cards/${story.author.imgName || 'default-author'}.png`)}
            className={styles.avator}
          />
        </div>
        <div className={styles['story-content']}>{story.story}</div>
      </div>
      {JSON.stringify(story.author) !== '{}' && story.author.desc.length > 0 && <AuthorInfoCard story={story} />}
    </CardPopupWrapper>
  )
}

export default StoryPopup
